class CardProductPilgrimSwatches {
  static init() {
    document.addEventListener('click', CardProductPilgrimSwatches.onClick);
  }

  static onClick(event) {
    const swatch = event.target.closest('.card-product-pilgrim__swatch');
    if (!swatch) return;

    event.preventDefault();

    const card = swatch.closest('.card-wrapper--pilgrim');
    if (!card) return;

    const variantId = swatch.dataset.variantId;
    if (!variantId) return;

    card.querySelectorAll('.card-product-pilgrim__swatch').forEach((item) => {
      item.classList.remove('card-product-pilgrim__swatch--active');
      item.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('card-product-pilgrim__swatch--active');
    swatch.setAttribute('aria-pressed', 'true');

    const addToCart = card.querySelector('add-to-cart.card-product-pilgrim__button');
    if (addToCart) {
      addToCart.dataset.variantId = variantId;

      if (swatch.dataset.available === 'false') {
        addToCart.setAttribute('disabled', 'true');
        addToCart.classList.add('card-product-pilgrim__button--soldout');
      } else {
        addToCart.removeAttribute('disabled');
        addToCart.classList.remove('card-product-pilgrim__button--soldout');
      }
    }

    const image = card.querySelector('.card-product-pilgrim__image--primary');
    if (image && swatch.dataset.imageSrc) {
      image.src = swatch.dataset.imageSrc;
      if (swatch.dataset.imageSrcset) {
        image.srcset = swatch.dataset.imageSrcset;
      }
      // Keep the selected variant image visible; don't let card hover swap to secondary.
      card.classList.add('card-wrapper--pilgrim-swatch-selected');
    }

    const priceEl = card.querySelector('.card-product-pilgrim__price');
    if (priceEl && swatch.dataset.price) {
      priceEl.textContent = swatch.dataset.price;
    }

    // The discount lives as a badge over the product image (top-right slot).
    const compareEl = card.querySelector('.card-product-pilgrim__compare');
    const discountSlot = card.querySelector('.card-product-pilgrim__discount-slot');
    const discountEl = discountSlot && discountSlot.querySelector('.card-product-pilgrim__discount');

    if (priceEl) {
      priceEl.classList.toggle('card-product-pilgrim__price--sale', Boolean(swatch.dataset.comparePrice));
    }

    if (swatch.dataset.comparePrice) {
      if (compareEl) {
        compareEl.textContent = swatch.dataset.comparePrice;
        compareEl.hidden = false;
      }
      if (discountSlot && discountEl && swatch.dataset.discount) {
        discountEl.textContent = swatch.dataset.discount;
        discountSlot.hidden = false;
      }
    } else {
      if (compareEl) compareEl.hidden = true;
      if (discountSlot) discountSlot.hidden = true;
    }
  }
}

CardProductPilgrimSwatches.init();
